/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

import { Capacitor } from "@capacitor/core";

const BASE_URL = Capacitor.isNativePlatform()
  ? "https://www.myambits.com"
  : "";

export function apiUrl(path: string): string {
  return `${BASE_URL}${path}`;
}
